import { render, staticRenderFns } from "./SupplierOnboardingContractsPage.vue?vue&type=template&id=11c35fe3&scoped=true&"
import script from "./SupplierOnboardingContractsPage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingContractsPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingContractsPage.vue?vue&type=style&index=0&id=11c35fe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c35fe3",
  null
  
)

export default component.exports